<template>
  <div class="news-card bg-ip-color-9 rounded-3xl md:rounded-[3.125vw] lg:rounded-[1.25vw] overflow-clip group hover:shadow-lg transition-shadow duration-300" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="200" data-aos-delay="100">
    <NuxtLink class="group/card text-white"
      :to="`${lang == 'id' ? `/post/${item.slug['id']}`:`/${lang}/post/${item.slug['id']}`}`"
    >
      <figure class="aspect-[397/224] bg-gray-50 group-hover/card:scale-105 transition duration-300">
        <img v-if="item.img_src" :src="config.public.cdnUrl+config.public.cdnFolder+item.img_src" class="w-full h-full object-cover" :alt="item.title[lang]" :title="item.title[lang]">
      </figure>
      <div class="px-4 py-3 md:px-[2.6vw] md:py-[3.125vw] lg:px-[1vw] lg:py-[1.25vw] space-y-3 md:space-y-[1.5vw] lg:space-y-[0.625vw] bg-ip-color-9 group-hover/card:-translate-y-12 transition duration-300">
        <div class="figtree text-xs md:text-base lg:text-[0.8vw]">{{ dayjs(item.publish_date).format('DD MMM YYYY') }}</div>
        <h1 class="figtree font-medium text-base md:text-xl lg:text-[1vw] leading-7 line-clamp-2">{{ item.title[lang] }}</h1>
        <div class="figtree text-sm md:text-base lg:text-[0.8vw] line-clamp-3">{{ stripHtml(item.content[lang]) }}</div>
        <div class="figtree group-hover/card:inline-flex text-sm md:text-base lg:text-[0.8vw] gap-1 text-ip-color-10 items-center hover:underline hover:bg-transparent btn bg-transparent p-0 shadow-none border-none absolute hidden font-normal group/cardlink">
          <span>{{ linkLang.url.text[lang] }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 group-hover/cardlink:translate-x-1 transition">
            <path fill-rule="evenodd" d="M5.22 14.78a.75.75 0 0 0 1.06 0l7.22-7.22v5.69a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0 0 1.5h5.69l-7.22 7.22a.75.75 0 0 0 0 1.06Z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
 
 
const lang = ref('id')
const config = useRuntimeConfig();
const dayjs = useDayjs();
const router = useRouter();
const props = defineProps({
  item: {
    publish_date: { type: String, default: 'Date' },
    title: { type: String, default: 'Title' },
    category: { type: String, default: 'Subtitle' },
    content: { type: String, default: 'Description' },
    target: { type: String, default: null },
    img_src: { type: String, default: null },
    slug: { type: String, default: null },
    categoryData: { type: String, default: null },
  },

});

const linkLang = ref({
  url: {
    text: {
      id: 'Read More',
      en: 'Read More',
    },
  },
});

dayjs.locale('en');

const stripHtml = (string) => {
  return string.replace(/<\/?[^>]+>/ig, ' ');
};
</script>

<style lang="scss" scoped>

</style>
